// ExternalThoughtModal.jsx
import React, { useState, useRef, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import Url from "app/shared/constants/Url";
import { useParams, useSearchParams } from "react-router-dom";
import {
    SuccessToast,
    ErrorToast,
  } from "app/shared/components/Popups/ToastMessage";
import AsyncSelect from "react-select/async";
import FetchEMList from "./services/fetchEMList";
import { set } from "react-hook-form";
import { useHistory } from "react-router-dom";
/**
 * Props:
 *  - show: boolean
 *  - onClose: () => void
 *  - defaultUsername?: string
 *  - originHeader?: string (default 'qaclide')
 *  - apiUrl?: string (default '/ClideAppSpring/safetythought/externalthought')
 */
const defaultState = {
  qrGenerateCode: 1,
  qrlink: 1,
  qrdownload: 1,
  employeeId: 1,
  employeeName: 1,
  capturePhoto: 1,
  captureVideo: 0,
  evidenceCount: 1,
  uploadFromGallary: 1,
  startDate: "",
  endDate: "",
  qrLinkUrl: "",
};

const parameterMap = {
  "Capture Photo": "capturePhoto",
  "Capture Video": "captureVideo",
  "Choose From Gallery": "uploadFromGallary",
  "Employee ID": "employeeId",
  "Employee Name": "employeeName",
  "Evidence": "evidenceCount",
  "Generate QR Code": "qrGenerateCode",
  "Link": "qrlink",
  "QR Downloadable": "qrdownload",
  "Start Date": "startDate",
  "End Date": "endDate",
};


const ExternalThoughtModal = ({
  show = true,
  onClose = () => { },
  defaultUsername = "",
  originHeader = "qaclide",
  apiUrl = Url.smDashboard.externalSafetyThoughtReport,
}) => {
  const [username, setUsername] = useState(defaultUsername);
  const [thoughtText, setThoughtText] = useState("");
  const [files, setFiles] = useState([]); // array of File
  const [recording, setRecording] = useState(false);
  const [recordBlob, setRecordBlob] = useState(null);
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [chunks, setChunks] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState(null);
  const fileInputRef = useRef(null);
  const { reference_id } = useParams();
  const [form, setForm] = useState(defaultState);
  const timeoutRef = useRef(null);
  const [submitted, setSubmitted] = useState(false);
  const history = useHistory();
  useEffect(() => {
    if (!show) {
      // reset fields when modal closed
      setThoughtText("");
      setFiles([]);
      setRecordBlob(null);
      setRecording(false);
      setChunks([]);
      setMessage(null);
      setUploading(false);
      if (defaultUsername) setUsername(defaultUsername);

    }
    fetchSettings();

  }, [show]);

  const validateBeforeSubmit = () => {
    if(form.employeeId === 0 && form.employeeName === 0){
    if (!username?.trim()) {
      ErrorToast("Please provide username.");
      return false;
    }}
  
    // ✅ Photo mandatory
    if (form.capturePhoto === 0) {
      const hasPhoto = files.some((file) =>
        file.type.startsWith("image/")
      );
  
      if (hasPhoto) {
        ErrorToast("Photo is not allowed. Please remove any image files");
        return false;
      }
    }

    if(form.evidenceCount < files.length + (recordBlob ? 1 : 0)){
      ErrorToast(`Maximum ${form.evidenceCount} files of evidence allowed. Please remove some files.`);
      return false;
    }
      const totalEvidence = files.length + (recordBlob ? 1 : 0);
  
    // ✅ Video mandatory
    if (form.captureVideo === 0) {
      const hasVideo =
        files.some((file) => file.type.startsWith("video/")) ||
        recordBlob;
  
      if (hasVideo) {
        ErrorToast("Video is not allowed. Please remove any video files");
        return false;
      }
    }
  
    // ✅ At least one content required
    if (!thoughtText?.trim() && files.length === 0 && !recordBlob) {
      ErrorToast(
        "Provide text, or attach a file/recording before submitting."
      );
      return false;
    }
  
    return true;
  };
  

  const generateReferenceId = () =>
    `${Date.now()}${Math.floor(Math.random() * 10000)}`;

  // drag & drop handlers
  const onDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const dropped = Array.from(e.dataTransfer.files || []);
    if (dropped.length) {
      setFiles((prev) => [...prev, ...dropped]);
    }
  };
  const onDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleChooseFiles = (e) => {
    const selected = Array.from(e.target.files || []);
    if (selected.length) setFiles((p) => [...p, ...selected]);
  };

  const removeFileAt = (index) =>
    setFiles((p) => p.filter((_, i) => i !== index));

  // audio recording (basic) - records webm
  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mr = new MediaRecorder(stream);
      setMediaRecorder(mr);
      setChunks([]);
      mr.ondataavailable = (ev) => {
        if (ev.data && ev.data.size > 0) {
          setChunks((prev) => [...prev, ev.data]);
        }
      };
      mr.start();
      setRecording(true);
    } catch (err) {
      console.error("Audio recording start failed:", err);
      alert("Cannot start audio recording (permission denied or not supported).");
    }
  };

  // const stopRecording = () => {
  //   if (!mediaRecorder) return;
  //   mediaRecorder.onstop = () => {
  //     const blob = new Blob(chunks, { type: "audio/webm" });
  //     setRecordBlob(blob);
  //     // stop all tracks
  //     mediaRecorder.stream?.getTracks().forEach((t) => t.stop && t.stop());
  //     setMediaRecorder(null);
  //     setRecording(false);
  //     setChunks([]);
  //   };
  //   mediaRecorder.stop();
  // };


  const getSafetyThoughtSetting = async () => {
    const token = localStorage.getItem("springToken");
    const userId = localStorage.getItem("userId");

    const response = await axios.get(
      Url.smDashboard.getSafetyThoughtSetting,
      {

      }
    );

    return response.data;
  };

  const fetchSettings = async () => {
    try {
      const res = await getSafetyThoughtSetting();

      if (res.status === 200 && res.data?.length > 0) {
        const updatedForm = { ...form };

        res.data.forEach((item) => {
          const key = parameterMap[item.parameter];

          if (key) {
            updatedForm[key] = item.value;
          }
        });

        setForm(updatedForm);
      }
    } catch (error) {
      console.error("Failed to fetch settings:", error);
    }
  };



  const handleSubmit = async () => {
    if (!username?.trim()) {
      ErrorToast("Please enter user name");
      return;
  }
  
    if (!validateBeforeSubmit()) return;

    setUploading(true);
    setMessage(null);

    try {
      const fd = new FormData();
      // required fields per swagger: is_file, safety_thought, external_user_name, file, record_file, reference_id
      const isFile = files.length > 0 ? "1" : "0";
      fd.append("is_file", isFile);
      fd.append("safety_thought", thoughtText || "");
      fd.append("external_user_name", username);
      // attach first file only (change as needed)
      if (files.length > 0) {
        files.forEach((file) => {
          fd.append("file", file, file.name);
        });
      }
      if (recordBlob) {
        // give a filename; server expects binary string
        fd.append("record_file", recordBlob, `record_${Date.now()}.webm`);
      }
      fd.append("reference_id", reference_id);
      fd.append("employee_id", form.searchEmployeeUsers?.value || "");
   
      const selectedEmployee = form.searchEmployeeUsers;

    

      const res = await axios.post(apiUrl, fd, {
        // optional: track progress
        onUploadProgress: (progressEvent) => {
          // percent = (progressEvent.loaded / progressEvent.total) * 100
        },
      });

      // success handling
      if(res.data.status === 200){
      setSubmitted(true);
      setMessage({
        type: "success",
        text: res?.data?.msg || "Submitted successfully.",
        data: res?.data,
      });
      setThoughtText("");
      setFiles([]);
      setForm((prev) => ({
        ...prev,
        searchEmployeeUsers: "",
      }));
      history.push("/thankyou/externalpage");

    }
      else{
        setMessage({
          type: "error",
          text: res?.data?.msg || "Submission failed.",
        });
      }

      // optionally close modal after success:
      // onClose();

    } catch (err) {
      console.error(err);
      setMessage({
        type: "error",
        text:
          err?.response?.data?.msg ||
          err.message ||
          "Failed to submit external thought",
      });
    } finally {
      setUploading(false);
    }
  };

  const searchClientEmployee = async (inputString) => {
    try {
      const response = await FetchEMList({ search: inputString });
  
      if (response.status === 200) {
        return response.data?.map((element) => ({
          ...element,
          label: element?.displayName,
          value: element?.clientEmployeeId,
        }));
      }
  
      return [];
    } catch (error) {
      return [];
    }
  };
  

  return (
    <Modal show={show} onHide={onClose} centered size="lg">
      <Modal.Header >
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          {/* small avatar placeholder */}

          <div>
            <div style={{ fontWeight: 700, fontSize: 16 }}>
              {"Safety Thought"}
            </div>
            <div style={{ fontSize: 12, color: "#777" }}>Safety Idea? We’re Listening! 👂</div>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body>
        {/* Username input */}
       
       

        {/* <div className="mb-3">
          <label className="form-label">Search Employee</label>

          <AsyncSelect
            isMulti={false}
            cacheOptions
            defaultOptions
            value={form.searchEmployeeUsers || []}
            placeholder="Search Employee"
            loadOptions={(inputValue) =>
              new Promise((resolve) => {
                if (timeoutRef.current) {
                  clearTimeout(timeoutRef.current);
                }

                timeoutRef.current = setTimeout(async () => {
                  if (!inputValue) {
                    resolve([]);
                    return;
                  }

                  const results = await searchClientEmployee(inputValue);
                  resolve(results);
                }, 500);
              })
            }
            onChange={(selected) => {
              setForm((prev) => ({
                ...prev,
                searchEmployeeUsers: selected,
              }));
              setUsername("");
            }}
          />
        </div> */}

        <div className="mb-3">
            <label className="form-label">Username</label>
            <input
              className="form-control"
              value={username}
              onChange={(e) => {
                setUsername(e.target.value)
                setForm((prev) => ({ ...prev, searchEmployeeUsers: null }))}
              }
              placeholder="Enter your name"
              autoFocus
            />
          </div>

        {/* Textarea */}
        <div className="mb-3">
          <label className="form-label">Thought</label>
          <textarea
            className="form-control"
            rows={3}
            value={thoughtText}
            onChange={(e) => setThoughtText(e.target.value)}
            placeholder="Write your safety thought..."
            style={{ resize: "vertical" }}
          />
        </div>

        {/* Drag & drop box */}
        <div
          onDrop={onDrop}
          onDragOver={onDragOver}
          style={{
            border: "2px dashed #ff7a00",
            borderRadius: 8,
            padding: 18,
            minHeight: 120,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            color: "#ff7a00",
            textAlign: "center",
            marginBottom: 12,
          }}
        >
          <div style={{ marginBottom: 8 }}>
            <strong>Drop files here or click to upload</strong>
          </div>
          <div style={{ fontSize: 13, color: "#666" }}>
            Supported file types: images, Videos, etc.
          </div>

          <input
            ref={fileInputRef}
            type="file"
            onChange={handleChooseFiles}
            style={{ display: "none" }}
            accept="image/*,video/*,audio/*" 
            // adjust if needed
          />
          <div style={{ marginTop: 12 }}>
            <button
              className="btn btn-outline-primary btn-sm"
              onClick={() => fileInputRef.current && fileInputRef.current.click()}
            >
              Choose file
            </button>
          </div>
        </div>

        {/* show chosen files */}
        {files.length > 0 && (
          <div className="mb-3">
            <strong>Attached files</strong>
            <ul className="list-unstyled mt-2">
              {files.map((f, idx) => (
                <li
                  key={idx}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "6px 8px",
                    border: "1px solid #eee",
                    borderRadius: 6,
                    marginBottom: 6,
                  }}
                >
                  <div style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis" }}>
                    {f.name} • {(f.size / 1024).toFixed(1)} KB
                  </div>
                  <div style={{ marginLeft: 12 }}>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => removeFileAt(idx)}
                    >
                      Remove
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* messages */}
        {message && (
          <div
            style={{
              marginTop: 12,
              padding: 10,
              borderRadius: 6,
              background: message.type === "error" ? "#ffe6e6" : "#e9f8ee",
              color: message.type === "error" ? "#a00" : "#066a2f",
            }}
          >
            {message.text}
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <div style={{ flex: 1, textAlign: "left" }}>

        </div>

        <Button style={{
          backgroundColor: "#F56620",
          borderColor: "#F56620",
          color: "#fff"
        }} onClick={handleSubmit} disabled={uploading}>
          {uploading ? "Uploading..." : "Upload"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ExternalThoughtModal;
